import VueI18n from 'vue-i18n';
import { computed } from 'vue';

let i18nInstance: VueI18n | undefined;
export function createI18n(options: VueI18n.I18nOptions) {
	i18nInstance = new VueI18n(options);
	return i18nInstance;
}

export function useI18n() {
	if (!i18nInstance) throw new Error('vue-i18n not initialized');

	const i18n = i18nInstance;
	const locale = computed({
		get: () => i18n.locale,
		set: v => (i18n.locale = v),
	});

	return {
		locale,
		t: i18n.t.bind(i18n),
		tc: i18n.tc.bind(i18n),
		d: i18n.d.bind(i18n),
		te: i18n.te.bind(i18n),
		n: i18n.n.bind(i18n),
		setLocaleMessage: i18n.setLocaleMessage.bind(i18n),
	};
}
